import { useCallback } from 'react';
import { Fade, Grid } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { COLORS } from 'theme/MainTheme';
import { navigateToSelectedChannelRoute } from 'utils/history';
import { FormattedMessage } from 'react-intl';
import Route from 'routes/Routes';
import { trackEvent, GACommonEventAction, GAEventCategory} from 'services/googleAnalytics';
import { useTourContext, useSelectedLinkContext } from 'contexts';
import { TOUR_STEPS } from '../App/OnBoarding/OnBoardingTour';
import clsx from 'clsx';
import {Profile} from 'components/icons';

const useStyles = makeStyles(() => ({
  container: {
    cursor: 'pointer',
  },
  icon: {
    float: 'left',
  },
  profileText: {
    fontSize: 14,
    fontWeight: 'bold',
    textAlign: 'end',
  },
  selected: {
    border: `2px solid ${COLORS.VIOLET}`,
  },
}), {name: 'ProfileButton'});

const ProfileButton = (): JSX.Element => {
  const classes = useStyles();

  const { selectedLink } = useSelectedLinkContext();
  const { currentStep, isTourOpen } = useTourContext();

  const onClick = useCallback(() => {
    trackEvent(GAEventCategory.BUTTON, GACommonEventAction.CLICK, 'Mon profil');
    navigateToSelectedChannelRoute(selectedLink, Route.PROFILE);
  }, [selectedLink]);
  
  const selectedClassName = isTourOpen && currentStep === TOUR_STEPS.PROFILE
    ? classes.selected
    : undefined;

  const show = !isTourOpen || currentStep >= TOUR_STEPS.PROFILE;
  return (
    <Fade in={show}>
      <div>
        <Grid
          className={clsx([
            classes.container,
            'tour-step-profile',
            selectedClassName,
          ])}
          container
          alignItems="center"
          onClick={onClick}
        >
          <Grid item xs={8} className={classes.profileText}>
            <FormattedMessage id="button.userAccount" />
          </Grid>
          <Grid item xs={4}>
            <Profile className={classes.icon} fontSize='xlarge' />
          </Grid>
        </Grid>
      </div>
    </Fade>
  );
};

export default ProfileButton;
